<template>
    <div class="root">
      <div class="content">
        <NavigationBar/>
        <h3>All Products</h3>
        <ProductsGrid :products="getAllProductData" v-if="getAllProductData && !getIsProductDataLoading"/>
        <div class="spinner-grow" role="status" v-else>
        </div>
        </div>
        <FooterView/>
    </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue';
import ProductsGrid from '../components/ProductsGrid.vue';
import FooterView from '../components/Footer.vue'
export default {
  name: 'AllProductsScreen',
  components: {
    NavigationBar,
    ProductsGrid,
    FooterView
  },
  data(){
    return {
    itemsInCart:0,
    }
  },
  methods:{
    incrementCount(){
        this.$store.dispatch('increment')
    },
    decreaseCount(){
        this.itemsInCart--
    }
  },
  computed:{
    getAllProductData(){
      return this.$store.state.allProducts  
    },
    getIsProductDataLoading(){
      return this.$store.state.isAllProductsLoading
    }
  },
  async mounted() {
    this.$store.dispatch('getAllProducts')
  }
  
}
</script>

<style scoped>
.root{
  display: flex;
  flex-direction: column;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
  flex: 1; /* takes all available space */
}
</style>